// src/store/slices/reviewRequestSlice.ts
// Pending "please review this" popups — pushed by useSocket.ts when the
// assignee submits a task for review, cleared when the assigner acts on
// (or dismisses) each one.
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ReviewRequest {
  taskId: string;
  title: string;
  fromName: string;
}

const reviewRequestSlice = createSlice({
  name: 'reviewRequest',
  initialState: [] as ReviewRequest[],
  reducers: {
    addReviewRequest: (state, action: PayloadAction<ReviewRequest>) => {
      if (!state.some(r => r.taskId === action.payload.taskId)) {
        state.push(action.payload);
      }
    },
    removeReviewRequest: (state, action: PayloadAction<string>) => {
      return state.filter(r => r.taskId !== action.payload);
    },
  },
});

export const { addReviewRequest, removeReviewRequest } = reviewRequestSlice.actions;
export default reviewRequestSlice.reducer;
